<template>
<div :class="['tui-chat', !isPC && 'tui-chat-h5','ai-desk-customer']" :key="currentLanguage">
    <div
      v-if="currentConversationID && (!props.showQueuePage || queueNumber < 0 || queueNumber === undefined || hasLeftQueue)"
      :class="['tui-chat', !isPC && 'tui-chat-h5','ai-desk-customer']"
    >
      <ChatHeader
        :class="[
          'tui-chat-header',
          !isPC && 'tui-chat-H5-header'
        ]"
        :canCloseChat="props.canCloseChat"
        :enableMultilingual="props.enableMultilingual"
        :langList="languageForShowList"
        :currentLang="currentLanguage"
        :headerConfig="props.headerConfig"
        @closeChat="closeChat"
        @changeLanguage="changeLanguage"
      />
      <MessageList
        ref="messageListRef"
        :class="['tui-chat-message-list', !isPC && 'tui-chat-h5-message-list']"
        @handleEditor="handleEditor"
        @closeInputToolBar="() => changeToolbarDisplayType('none')"
        :bottomQuickOrder="props.bottomQuickOrder"
        :showBottomQuickOrder="showBottomQuickOrder"
        @closeBottomQuickOrder="closeBottomQuickOrder"
        :enableFeedback="props.enableFeedback"
        :enableAINote="props.enableAINote"
        @like="onLike"
        @dislike="onDislike"
      />
      <MessageToolbarButton
        v-if="props.toolbarButtonList && (!isH5 || (!Boolean(quoteMessage) && !showBottomQuickOrder))"
        :toolbarButtonList="props.toolbarButtonList"
      />
      <MessageInputToolbar
        v-if="isInputToolbarShow"
        :class="[
          'tui-chat-message-input-toolbar',
          !isPC && 'tui-chat-h5-message-input-toolbar'
        ]"
        :displayType="inputToolbarDisplayType"
        :inputToolbarList="props.inputToolbarList"
        @insertEmoji="insertEmoji"
        @changeToolbarDisplayType="changeToolbarDisplayType"
        @scrollToLatestMessage="scrollToLatestMessage"
      />
      <MessageInput
        ref="messageInputRef"
        :class="[
          'tui-chat-message-input',
          !isPC && 'tui-chat-h5-message-input'
        ]"
        :isMuted="isMuted"
        :muteText="muteText"
        :placeholder="TUITranslateService.t('TUIChat.请输入消息')"
        :inputToolbarDisplayType="inputToolbarDisplayType"
        :inputToolbarList="props.inputToolbarList"
        :enableSendingAudio="props.enableSendingAudio"
        @changeToolbarDisplayType="changeToolbarDisplayType"
        @emojiShow="emojiShow"
        @toolShow="toolShow"
        @blurToolAndEmojiH5="blurToolAndEmojiH5"
        @messageSent="onMessageSent"
      />
      <div class="input-toolbar-h5">
        <div :class="['emoji-dialog-h5',(toolShowH5 && !emojiOpen)?'tool-dialog-h5':'']">
          <div v-if="emojiOpen">
            <EmojiDialog
              @insertEmoji="insertEmoji"
               @sendMessage="sendMessage"
            />
          </div>
          <MessageInputToolbar
            v-if="!isPC"
            :class="[
              'tui-chat-message-input-toolbar',
              !isPC && 'tui-chat-h5-message-input-toolbar'
            ]"
            :isH5ToolShow="toolShowH5"
            :displayType="inputToolbarDisplayType"
            :inputToolbarList="props.inputToolbarList"
            @insertEmoji="insertEmoji"
            @changeToolbarDisplayType="changeToolbarDisplayType"
            @scrollToLatestMessage="scrollToLatestMessage"
            @sendMessage="sendMessage"
          />
        </div>
      </div>
        <FeedbackModal
          ref="feedbackModalRef"
          v-show="showFeedbackModal"
          @close="() => { showFeedbackModal = false }"
        />
    </div>
    <div v-if="props.showQueuePage && queueNumber >= 0 && !hasLeftQueue" :class="['tui-chat', !isPC && 'tui-chat-h5']">
      <CustomerQueuePage :queueNumber="queueNumber" @closeQueuePage="closeQueuePage"/>
    </div>
  </div>
</template>
<script lang="ts" setup>
import vue from '../../adapter-vue';
import {
  IMessageModel,
  StoreName,
  TUIChatEngine,
  TUIConversationService,
  TUIStore,
  TUITranslateService,
} from '../../@aidesk/uikit-engine';
import ChatHeader from './chat-header/index-web.vue';
import MessageList from './message-list/index-web.vue';
import MessageInput from './message-input/index-web.vue';
import MessageInputToolbar from './message-input-toolbar/index-web.vue';
import EmojiDialog from './message-input-toolbar/emoji-dialog-mobile/emoji-dialog-mobile.vue';
import { isH5, isPC } from '../../utils/env';
import { ToolbarButtonModel, ToolbarDisplayType, InputToolbarModel, QuickOrderModel, IHeaderConfig, IMessageToolDisplayConfig } from '../../interface';
import Log from '../../utils/logger';
import MessageToolbarButton from './message-toolbar-button/index.vue';
import TUILocales from '../../locales';
import state from '../../utils/state.js';
import { switchReadStatus, isNonEmptyObject } from '../../utils/utils';
import { getCountryForTimezone } from 'countries-and-timezones';
import FeedbackModal from './feedback-modal/index.vue';
import CustomerQueuePage from './customer-queue-page/index.vue';
import { startHeartbeat, stopHeartbeat, sendHeartbeat } from '../../utils/heartbeat-handler';
const { ref, onMounted, onUnmounted, computed } = vue;

interface IProps {
  canCloseChat?: boolean;
  SDKAppID?: number;
  userID?: string;
  userSig?: string;
  robotLang?: string;
  userLang?: string;
  toolbarButtonList?: ToolbarButtonModel[];
  showAvatar?: number;
  robotAvatar?: string;
  memberAvatar?: string;
  userAvatar?: string;
  showNickName?: number;
  robotNickName?: string;
  memberNickName?: string;
  userNickName?: string;
  enableUnifiedMemberProfile?: number;
  inputToolbarList?: InputToolbarModel[];
  showReadStatus?: number;
  showTyping?: number;
  bottomQuickOrder?: QuickOrderModel;
  enableMultilingual?: number;
  langList?: Array<string>;
  enableFeedback?: number;
  enableAINote?: number;
  enableURLDetection?: number;
  headerConfig?: IHeaderConfig;
  enableSendingAudio?: number;
  showQueuePage?: number;
  showAllRobotWelcomeItems?: number;
  messageToolDisplayConfig?: IMessageToolDisplayConfig[];
}

const emits = defineEmits(['closeChat']);

const currentConversationID = ref();
const inputToolbarDisplayType = ref<ToolbarDisplayType>('none');
const messageInputRef = ref();
const isMuted = ref(false);
const muteText = ref('');
const messageListRef = ref<InstanceType<typeof MessageList>>();
const emojiOpen = ref(false);
const toolShowH5 = ref(false);
const languages = Object.keys(TUILocales);
const quoteMessage = ref<IMessageModel>();
const showBottomQuickOrder = ref(false);
const currentLanguage = ref('');
const languageForShowList = ref<Array<string>>([]);
const feedbackModalRef = ref();
const showFeedbackModal = ref(false);
const queueNumber = ref(-1); 
const queueLeavePageTimeoutEnable = ref(false);
const hasLeftQueue = ref(false);
let timezone = '';
let countryID = '';
const props = withDefaults(defineProps<IProps>(), {
  canCloseChat: true,
  SDKAppID: 0,
  userID: '',
  userSig: '',
  robotLang: '',
  userLang: '',
  showReadStatus: 1,
  showAvatar: 1,
  robotAvatar: '',
  memberAvatar: '',
  userAvatar: '',
  showNickName: 0,
  robotNickName: '',
  memberNickName: '',
  userNickName: '',
  enableUnifiedMemberProfile: 1,
  showTyping: 0,
  enableMultilingual: 0,
  enableFeedback: 0,
  enableAINote: 1,
  langList: () => [],
  enableURLDetection: 0,
  enableSendingAudio: 0,
  showQueuePage: 0,
  showAllRobotWelcomeItems: 0,
});

const getTimeZoneAndCountry = () => {
  timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const country = getCountryForTimezone(timezone);
  countryID = country && country.id ? country.id : '';
}

const convertLanguageToLowercase = (language) => {
  let lowercase = language.toLowerCase();
  if (lowercase === 'zh-cn' || lowercase === 'zh_cn') {
    lowercase = 'zh';
  } else if (lowercase === 'zh-tw' || lowercase === 'zh-hk') {
    lowercase = 'zh_tw';
  }
  return lowercase;
}

const getValidLanguage = (language: string) => {
  let validLanguage = '';
  if (props.enableMultilingual === 1 && languageForShowList.value.length !== 0) {
    if (languageForShowList.value.includes(language)) {
      validLanguage = language;
    } else {
      // choose default language (languageForShowList.value[0] for uikit) if language is not supported
      validLanguage = languageForShowList.value[0];
    }
  } else if (languages.includes(language)) {
    validLanguage = language;
  } else {
    if (props.userLang !== ''){
      Log.w(`userLang:${props.userLang} is not supported`);
    }
    validLanguage = 'en';
  }
  return validLanguage;
}

const initLanguage = () => {
  Log.i(`initLanguage ${props.userLang}`);
  TUITranslateService.provideLanguages({ ...TUILocales });
  TUITranslateService.useI18n();
  if (props.enableMultilingual === 1) {
    languageForShowList.value = props.langList.filter(language => languages.includes(language));
  }
  let language;
  try {
    const prevLanguage = localStorage.getItem('AIDesk_language');
    if (prevLanguage) {
      language = prevLanguage;
    }
  } catch {
    Log.w('No Previous Language');
  }
  if (!language) {
    if (props.userLang !== '') {
      let userLang = convertLanguageToLowercase(props.userLang);
      language = getValidLanguage(userLang);
    } else {
      let navigatorLang = convertLanguageToLowercase(navigator.language);
      language = getValidLanguage(navigatorLang);
    }
  }
  currentLanguage.value = language;
  state.set('currentLanguage', language);
  TUITranslateService.changeLanguage(language);
}

const setAvatarNickName = () => {
  state.set('avatarNickName', {
    showAvatar: props.showAvatar,
    showNickName: props.showNickName,
    userAvatar: props.userAvatar,
    memberAvatar: props.memberAvatar,
    robotAvatar: props.robotAvatar,
    userNickName: props.userNickName,
    memberNickName: props.memberNickName,
    robotNickName: props.robotNickName,
    enableUnifiedMemberProfile: props.enableUnifiedMemberProfile,
  });
}

const setShowReadStatus = () => {
  state.set('showReadStatus', props.showReadStatus);
}

const setShowTyping = () => {
  state.set('showTyping', props.showTyping);
}

const setEnableURLDetection = () => {
  state.set('enableURLDetection', props.enableURLDetection);
}

const setShowAllRobotWelcomeItems = () => {
  state.set('showAllRobotWelcomeItems', props.showAllRobotWelcomeItems);
}

const setMessageToolDisplayConfig = () => {
  state.set('messageToolDisplayConfig', props.messageToolDisplayConfig || []);
}

try {
  initLanguage();
  setAvatarNickName();
  setShowReadStatus();
  setShowTyping();
  setEnableURLDetection();
  setShowAllRobotWelcomeItems();
  getTimeZoneAndCountry();
  setMessageToolDisplayConfig();
  if (isNonEmptyObject(props.bottomQuickOrder)) {
    showBottomQuickOrder.value = true;
  }
} catch (e) {
  console.log(e)
}

onMounted(() => {
  // 如果组件挂载在 sdk login 之后，需再次设置 displayMessageReadReceipt，确保状态准确
  if (TUIChatEngine.isReady()) {
    switchReadStatus(state.get('showReadStatus'));
  }

  TUIStore.watch(StoreName.CONV, {
    currentConversationID: onCurrentConversationIDUpdate,
  });
  TUIStore.watch(StoreName.USER, {
    kickedOut: onKickedOut
  });
  TUIStore.watch(StoreName.CHAT, {
    quoteMessage: onQuoteMessageUpdated,
  });
  TUIStore.watch(StoreName.CUSTOM, {
    isQueuing: onIsQueuingUpdate,
    queueLeavePageTimeoutEnable: onQueueLeavePageTimeoutEnable,
  });
  document.addEventListener('visibilitychange', handleVisibilityChange);
});

onUnmounted(() => {
  TUIStore.unwatch(StoreName.CONV, {
    currentConversationID: onCurrentConversationIDUpdate,
  });
  TUIStore.unwatch(StoreName.USER, {
    kickedOut: onKickedOut
  });
  TUIStore.unwatch(StoreName.CHAT, {
    quoteMessage: onQuoteMessageUpdated,
  });
  TUIStore.unwatch(StoreName.CUSTOM, {
    isQueuing: onIsQueuingUpdate,
    queueLeavePageTimeoutEnable: onQueueLeavePageTimeoutEnable,
  });
  document.removeEventListener('visibilitychange', handleVisibilityChange);
  stopHeartbeat();
});

const isInputToolbarShow = computed<boolean>(() => {
  return (isH5) ? inputToolbarDisplayType.value !== 'none' : true;
});

const reset = () => {
  TUIConversationService.switchConversation('');
};

const closeChat = (conversationID: string) => {
  emits('closeChat', conversationID);
  reset();
};

const insertEmoji = (emojiObj: object) => {
  messageInputRef.value?.insertEmoji(emojiObj);
};
const sendMessage = () => {
  messageInputRef.value?.sendMessage();
}

const onMessageSent = () => {
  // 发送消息后列表滚动到底部
  messageListRef.value?.scrollToLatestMessage();
}

const handleEditor = (message: IMessageModel, type: string) => {
  if (!message || !type) return;
  switch (type) {
    case 'reference':
      // todo
      break;
    case 'reply':
      // todo
      break;
    case 'reedit':
      if (message?.payload?.text) {
        messageInputRef?.value?.reEdit(message?.payload?.text);
      }
      break;
    default:
      break;
  }
};

function changeToolbarDisplayType(type: ToolbarDisplayType) {
  inputToolbarDisplayType.value
    = inputToolbarDisplayType.value === type ? 'none' : type;
}

function scrollToLatestMessage() {
  messageListRef.value?.scrollToLatestMessage();
}

function onKickedOut(type: string) {
  if (type) {
    isMuted.value = true;
    muteText.value = TUITranslateService.t('TUIChat.账号被强制下线');
  }
}

function onCurrentConversationIDUpdate(conversationID: string) {
  if (!conversationID) {
    return;
  }

  currentConversationID.value = conversationID;
  activeConversation();
}

function emojiShow(){
  if(toolShowH5.value === true){
    toolShowH5.value = false;
  }
  emojiOpen.value = !emojiOpen.value;

}

function toolShow(){
  if(emojiOpen.value === true){
    emojiOpen.value = false;
  }
  toolShowH5.value = !toolShowH5.value;
}

function blurToolAndEmojiH5() {
  if (emojiOpen.value === true) {
    emojiOpen.value = false;
  }
  toolShowH5.value = false;
}

function onQuoteMessageUpdated(options?: {
  message: IMessageModel;
  type: string;
}) {
  if (options?.message && options?.type === 'quote') {
    quoteMessage.value = options.message;
  } else {
    quoteMessage.value = undefined;
  }
}

function closeBottomQuickOrder() {
  showBottomQuickOrder.value = false;
}

function changeLanguage(languageCode: string) {
  Log.l(`multilingual: change language to ${languageCode}`);
  TUITranslateService.changeLanguage(languageCode).then(() => {
    currentLanguage.value = languageCode;
    state.set('currentLanguage', languageCode);
    try {
      localStorage.setItem('AIDesk_language', languageCode);
    } catch {
      Log.w("Failed to set language to localStorage.");
    }
    activeConversation();
  });
}

function activeConversation() {
  TUIStore.update(StoreName.CUSTOM, 'activeConversation', {
    conversationID: currentConversationID.value,
    robotLang: props.robotLang && languages.includes(props.robotLang) ? props.robotLang : currentLanguage.value === 'zh_tw' ? 'zh-TW' : currentLanguage.value,
    country: countryID,
    timezone: timezone,
  });
}

function onLike(type: number, messageInfo: Object) {
  feedbackModalRef.value.onLike(type, messageInfo);
}

function onDislike(type: number, messageInfo: Object) {
  if (type === 2) {
    showFeedbackModal.value = true;
  }
  feedbackModalRef.value.onDislike(type, messageInfo);
}

function onIsQueuingUpdate(data: {conversationID: string, value: number}) {
  if (data && data.conversationID === currentConversationID.value) {
    queueNumber.value = data.value;
    hasLeftQueue.value = false;
    if (queueNumber.value >= 0) {
      startHeartbeat();
    } else {
      stopHeartbeat();
    }
  }
}

function onQueueLeavePageTimeoutEnable(data: boolean) {
  queueLeavePageTimeoutEnable.value = data;
  startHeartbeat();
}

const handleVisibilityChange = () => {
  if (document.visibilityState === 'hidden') {
    if (queueLeavePageTimeoutEnable.value && queueNumber.value >= 0) {
      sendHeartbeat(currentConversationID.value, "leaveSessionPage");
    }
    stopHeartbeat();
  } else if (document.visibilityState === 'visible') {
    startHeartbeat();
  }
}

function closeQueuePage() {
  hasLeftQueue.value = true;
}
</script>

<style scoped lang="scss" src="./style/index.scss">

</style>
